@if (languages?.length > 1) {
  <div class="language-switcher">
    <button
      mat-button
      class="button button--transparent primary-menu-button"
      [class.button--icon]="!showSelected"
      #languageSelectButton
      (click)="openLanguageSwitcher(languageSelectButton)">
      <lib-icon icon="globe"></lib-icon>
      @if (currentLanguage && showSelected) {
        <div class="selected-language">{{languagesMap[currentLanguage]?.name}}</div>
        <lib-icon class="select-language-icon" icon="caret-down" [size]="16" [bold]="true"></lib-icon>
      }
    </button>
    <div class="language-menu-trigger" #languageMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="languageMenu"></div>
  </div>
}
<mat-menu #languageMenu="matMenu" class="language-menu primary-menu">
  @for (language of languages; track language) {
    <button
      mat-menu-item
      class="primary-menu-button primary-button-dark-hover mat-menu-item"
      [ngClass]="{'primary-button-dark': language.code === currentLanguage}"
      (click)="changeCurrentLanguage(language.code)">
      <span class="align-middle" [attr.lang]="language.code">{{language.name}}</span>
    </button>
  }
</mat-menu>
